import {
  AccountStatusVariant,
  LandlordVerificationStatus,
  LeaseVerificationStatus,
  PendingIdentityVerificationStatus,
  RvStatus
} from "./constants";
import { Renter, RvStatusType } from "./types";
import { Subscriber } from "views/rent-reporting-id/types";

export const getDisplayAccountStatus = (
  renter: Renter | Subscriber
): AccountStatusVariant => {
  // Subscriber type uses account_status field directly
  if ("account_status" in renter)
    renter = { ...renter, type: renter.account_status } as Subscriber;

  // Renter type uses type field with additional logic
  const renterType = renter as Renter;
  if (renterType.type === AccountStatusVariant.Pending) {
    if (renterType.case_status === AccountStatusVariant.PendingOptIn)
      return AccountStatusVariant.PendingOptIn;

    if (renterType.case_status === AccountStatusVariant.PendingOptOut)
      return AccountStatusVariant.PendingOptOut;

    if (
      [
        PendingIdentityVerificationStatus.Pending,
        PendingIdentityVerificationStatus.Rejected
      ].includes(renterType.identity_verification_status)
    )
      return AccountStatusVariant.PendingIDV;
    if (
      [
        LeaseVerificationStatus.Pending,
        LeaseVerificationStatus.Rejected
      ].includes(renterType.lease_verification_status)
    )
      return AccountStatusVariant.PendingLeaseVerification;
    if (
      [
        LandlordVerificationStatus.Pending,
        LandlordVerificationStatus.Rejected
      ].includes(renterType.landlord_verification_status)
    )
      return AccountStatusVariant.PendingLandlordVerification;
  }

  return renterType.type as AccountStatusVariant;
};

export function getRvStatusText(status: RvStatusType | null): string {
  if (!status) return "--";
  switch (status.status) {
    case RvStatus.Verified:
    case RvStatus.PendingConfirmation:
      if (status.months_delinquency === 0) return "Paid on-time";
      else return `${status.months_delinquency} + months late`;
    default:
      return "No data";
  }
}
